
<div class="project-container" appClickOutside (clickOutside)="onclickOutside()">
  <nz-input-group [nzSuffix]="iconSide === 'right' ? iconSideTemplate : ''"
    [nzPrefix]="iconSide === 'left' || iconSide === undefined ? iconSideTemplate : ''" class="input-projects">
    <ng-template #iconSideTemplate>
      <span nz-icon nzType="search"></span>
    </ng-template>
    <input nz-input
      (focus)="onInputfocus()"
      autocomplete="off"
      [disabled]="!enabled" id="search-input"
      [placeholder]="searchValue ? null : 'Selecciona un proyecto'"
      [value]="searchValue" (input)="fnSearchValue($event)" />
  </nz-input-group>
    <div (click)="onClickContainer($event)" *ngIf="isShowingMenu" 
      class="menu-projects">
      <nz-tabset #tabset_projects (nzSelectChange)="setTabActive([$event])" [nzAnimated]="false">
        <nz-tab nzTitle="Todos los proyectos">
          <nz-list nzItemLayout="horizontal" [nzLoading]="loading" class="infinite-container">
            <nz-list-item class="item" *ngIf="projects.length != 0 && !searchValue" (click)="selectProject('all')">
              <span nz-typography>Todos</span>
            </nz-list-item>
            <nz-list-item class="item" *ngFor="let item of projects"
              (click)="selectProject(item)">
              <span nz-typography [innerHTML]="item.projectName | highlighter:searchValue"></span>
            </nz-list-item>
          </nz-list>
          <nz-list-empty *ngIf="projects.length == 0" />
        </nz-tab>
        <nz-tab nzTitle="Proyectos por empresa">
          <nz-collapse nzGhost>
            <nz-collapse-panel [nzHeader]="company.key" *ngFor="let company of projectsGroupedByCompany | keyvalue">
              <nz-list nzItemLayout="horizontal" [nzLoading]="loading" class="infinite-container">
                <nz-list-item class="item" *ngFor="let item of company.value"
                  (click)="selectProject(item)">
                  <span nz-typography [innerHTML]="item.projectName | highlighter:searchValue"></span>
                </nz-list-item>
              </nz-list>
            </nz-collapse-panel>
            <nz-list-empty *ngIf="!hasProjectGroupBy()" />
          </nz-collapse>
        </nz-tab>
      </nz-tabset>
    </div>
  <ng-template #search><span nz-icon nzType="search"></span></ng-template>
</div>
